import React, { useEffect, useState } from "react";

import { sql, PostgreSQL } from "@codemirror/lang-sql";
import CodeMirror from "@uiw/react-codemirror";

import ingestionDataApi from "apis/ingestionData";
import { Dropdown } from "clearsense-ui/components";

const Editor = ({
  sqlQuery,
  isFetching,
  isExecutingSQL,
  setSqlQuery,
  setShowCreateViewModal,
  onExecuteButtonClick,
  theme,
}) => {
  const [suggestions, setSuggestions] = useState({});

  const fetchSuggestions = async () => {
    try {
      const { data } = await ingestionDataApi.fetchSuggestions();
      setSuggestions(data.result);
    } catch (err) {
      logger.log(err);
    }
  };

  useEffect(() => {
    fetchSuggestions();
  }, []);

  return (
    <div className="m-5 border">
      <CodeMirror
        value={sqlQuery}
        height="180px"
        placeholder="SELECT * FROM ..."
        options={{
          autoCloseBrackets: false,
        }}
        onChange={query => setSqlQuery(query)}
        extensions={[
          sql({
            dialect: PostgreSQL,
            upperCaseKeywords: true,
            schema: suggestions,
          }),
        ]}
        data-cy="sql-query-editor-input"
        theme={theme}
      />
      <div className="flex flex-wrap items-center p-4 border-t bg-white dark:bg-cs-ui-gray-800 space-x-4">
        <Dropdown
          label="Run"
          disabled={isFetching}
          primaryButtonClass="px-8"
          data-cy="sql-query-run-dropdown-button"
          primaryAction={() => onExecuteButtonClick("")}
          primaryButtonProps={{
            loading: isExecutingSQL,
          }}
          buttonProps={{
            iconPosition: "right",
            disabled: sqlQuery.length === 0,
          }}
        >
          <li
            data-cy="sql-create-view-option"
            onClick={() => setShowCreateViewModal(true)}
          >
            Create View As
          </li>
        </Dropdown>
      </div>
    </div>
  );
};

export default Editor;
